import { useMemo } from 'react';
import { useAiRecommendationsForQuery } from '.';
import { useLesson } from '../lessons';
import { useShort } from '../shortContent';
import { useTrack } from '../tracks';
import words from 'hs-lodash/words';
const MAX_AI_QUERY_KEYWORDS = 200;
const useAcademyAiQueryForRecommendations = ({
  id,
  type,
  language
}) => {
  const {
    track
  } = useTrack(id, language, type !== 'TRACK');
  const {
    lesson
  } = useLesson(id, language, type !== 'LESSON');
  const {
    short
  } = useShort(id, language, type !== 'SHORT_FORM_CONTENT' || !language);
  const {
    name,
    description
  } = track ? {
    name: track.name,
    description: track.description
  } : lesson ? {
    name: lesson.name,
    description: lesson.description
  } : short ? {
    name: short.name,
    description: short.description
  } : {
    name: '',
    description: ''
  };
  return useMemo(() => {
    const tName = name.trim();
    const tDescription = description.trim();
    if (!tName.length && !tDescription.length) return null;

    // truncates the query size to the max number of keywords accepted by AcademyAI services
    return words(`${tName} ${tDescription}`).slice(0, MAX_AI_QUERY_KEYWORDS).join(' ');
  }, [description, name]);
};
export const useAiRecommendationsForLearningContent = ({
  item,
  skip,
  size = 5
}) => {
  const query = useAcademyAiQueryForRecommendations(item);
  const {
    language
  } = item;
  const {
    recommendations,
    recommendationsLoading,
    recommendationsError
  } = useAiRecommendationsForQuery({
    language: language,
    query: query,
    numberOfResults: size,
    skip: skip || !language || !query
  });
  return {
    recommendations: recommendations ? recommendations.map(({
      recommendationId,
      recommendationType
    }) => {
      return {
        id: recommendationId,
        type: recommendationType,
        language
      };
    }) : null,
    recommendationsLoading,
    recommendationsError
  };
};